import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateDepartment = ({ visible, handleClose, initialData='', onSubmit }) => {
    
    const formik = useFormik({
        initialValues: {
            name: initialData?.departmentName || '',
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .required('Department Name is required'),
        }),
        onSubmit: (values,{resetForm}) => {
            if(initialData?.departmentName){
                onSubmit({"sp": "usp_UpdateDepartment","solutionId":1,departmentName:values?.name,departmentId:initialData?.departmentId});
                onClose();
            }else{
                onSubmit({"sp": "usp_InsertDepartment","solutionId":1,departmentName:values?.name});
                onClose();
            }
        },
    });

    const onClose = ()=>{
        formik.resetForm();
        handleClose();
    }

    useEffect(()=>{
        if(initialData?.departmentName){
            formik.setFieldValue('name',initialData?.departmentName)
        }
    },[initialData])

    return (
        <Modal
            title={initialData ? "Edit Department" : "Create New Department"}
            visible={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            width={600} // Adjust modal width
            className="custom-modal-header p-0"
            maskClosable={false}
        >
            <form onSubmit={formik.handleSubmit}>
                <div className="" role="document"  >
                    <div>
                        <div>
                            <div className="row g-3">

                                <div className="col-md-12" >
                                    <label className="form-label  fs-7 ">Department Name</label> <span className='text-danger'>*</span>
                                    <input
                                        type="text"
                                        className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                        placeholder="Enter department name"
                                        name="name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                    />
                                    <span style={{ color: 'red' }} role="alert">{formik.errors.name}</span>
                                </div>

                            </div>
                        </div>

                        <div className="modal-footer mt-3">
                            <button type="button" className="btn btn-light" onClick={handleClose}>
                                Close
                            </button>
                            <button type="submit" className="btn btn-primary ms-3">
                                {initialData ? "Update" : "Add"}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

// CreateDepartment.propTypes = {
//     visible: PropTypes.bool.isRequired,
//     handleClose: PropTypes.func.isRequired,
//     initialData: PropTypes.shape({
//         name: PropTypes.string,
//     }),
//     onSubmit: PropTypes.func.isRequired,
// };

export default CreateDepartment;
